export const language = {
  getLanguage() {
    const selectedLang = localStorage.getItem("selectedLanguage");

    if (selectedLang) {
      return selectedLang;
    }

    const longLang = navigator ? navigator.language : "en-US";
    const shortLang = longLang.split("-")[0];

    if (shortLang === "zh") {
      if (longLang === "zh-HK" || longLang === "zh-TW") {
        return longLang;
      } else {
        // 이외의 중국어는 모두 zh-CN으로 일괄처리
        return "zh-CN";
      }
    }
    if (shortLang === "es") {
      // 구주 스페인어, 중남미 스페인어 분기
      return longLang === "es-ES" ? longLang : shortLang;
    }
    if (longLang === "uk-UA") {
      return longLang;
    }
    if(longLang ==="nb" || longLang ==="nn")
    {
      return "no";
    }

    return shortLang;
  },
  setLanguage(val) {
    localStorage.setItem("selectedLanguage", val);
  }
};
